import { useSelector } from "react-redux";

export default function useHasPermission(key, method) {
  return useSelector((state) => {
    if (method) return !!state.Login?.data?.permissions?.[key]?.includes(method)
    return !!state.Login?.data?.permissions?.[key]?.length
  });
}
